import { EnumTipoCalculo, KeyValueModel } from "model";

export const TpCalculosMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoCalculo.Fixo, "Fixo"),
    new KeyValueModel(EnumTipoCalculo.Modulo, 'Módulo'),
    new KeyValueModel(EnumTipoCalculo.Bilhetagem, "Bilhetagem"),
];
